import { render, staticRenderFns } from "./EventControlPanelLateArrivalDialog.vue?vue&type=template&id=806633be&scoped=true&"
import script from "./EventControlPanelLateArrivalDialog.vue?vue&type=script&lang=js&"
export * from "./EventControlPanelLateArrivalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806633be",
  null
  
)

export default component.exports